import React from "react"
import { connect, useSelector } from "react-redux"
import { withRouter, Redirect, Switch, Route } from "react-router-dom"
import Toggle from './components/toggle'
import Login from './components/login'
import Signup from './components/signup'
import Invitation from './components/invitation'
import Payment from './components/payment'
import Forgot from './components/forgot'
import Reset from './components/reset'
import MFA from './components/mfa'
import { ReactComponent as Logo } from "@src/media/logos/cinesend/cinesend_red_s.svg"

const Form = ({ authenticated }) => {
  const externalAuthentication = useSelector(state => state.auth?.externalAuthentication.external_authentication_enabled)
  return (
    <>
      {authenticated && <Redirect to='/'/>}
      <section
        className='flex items-center justify-center col-12 mx-auto'
        style={{
          minHeight: '550px',
          width: '420px'
        }}>
        <div className='col-12'>
          <div className='center mb3'>
            <Logo style={{ width: '142px', height: '56px' }}/>
          </div>
          <div className='bg-white rounded mb2' style={{ padding: '3rem' }}>
            <Switch>
              <Route path='/login' component={Login}/>
              <Route path='/invite' component={Invitation}/>
              <Route path='/signup' component={Signup}/>
              <Route path='/payment' component={Payment}/>
              <Route path='/forgot' component={Forgot}/>
              <Route path='/reset-password' component={Reset}/>
              <Route path='/mfa' component={MFA}/>
            </Switch>
            {!externalAuthentication && <Toggle/>}
          </div>
        </div>
      </section>
    </>
  )
}

const mapStateToProps = state => ({
  account: state.account,
  authenticated: state.auth.status === "AUTHENTICATED"
})

export default withRouter(connect(mapStateToProps)(Form))
